// extracted by mini-css-extract-plugin
export const logo = "logo-module--logo--2Wc5b";